export default __webpack_public_path__ + "static/media/phone.22ae2bfa.svg";